/****************************************************
 * Module Name:  addVirtualTeamModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip, Typography } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import Utility from "../../utility/utility";
import UserProxy from "../../utility/proxy/manager/userProxy";
import VirtualTeamProxy from "../../utility/proxy/manager/permissionProxy/virtualTeamProxy";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';
import Select from "react-select";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const fullOptionToUserValue = (selectedData) => {
  let newArr = [];
  selectedData.map((option) => {
    newArr.push({ userid: option.value });
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

const fullOptionToOwnerValue = (selectedData) => {
  let newArr = [];
  selectedData.map((option) => {
    newArr.push({ userid: option.value });
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

const setPropSourceDataofVirtualTeam = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.userid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

const setPropSourceDataofVirtualTeamUsers = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.userid, label: item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

export default class AddVirtualTeamModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newUser: this.props.editOperation
        ? setPropSourceDataofVirtualTeamUsers(
          this.props.sourceData.virtualteamusers
        )
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newVirtualTeamOwners: this.props.editOperation
        ? setPropSourceDataofVirtualTeam(
          this.props.sourceData.virtualteamowners
        )
        : "",
      newVirtualTeam: this.props.editOperation
        ? this.props.sourceData.name
        : "",

      showError: false,

      validateVirtualTeamPresentSpinner: false,
      showValidationMessage: false,
      virtualTeamAvailable: true,

      userOwnerOptions: [],
      showUserOwnerLoadSpinner: true,

      userOptions: [],
      showUserLoadSpinner: true,

      virtualTeamValidationError: "",
      userInputValue: "",
      ownerInputValue: "",
      debouncedUserInputValue: "",
      debouncedOwnerInputValue: "",
      showUserDetailModal: false,
      userDetailContext: "",
    };
    this.getAllUser();
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleDebounce("userInputValue", "debouncedUserInputValue", prevState, this.state);
    this.handleDebounce("ownerInputValue", "debouncedOwnerInputValue", prevState, this.state);
  }

  handleDebounce(inputState, debouncedState, prevState, currentState) {
    if (prevState[inputState] !== currentState[inputState]) {
      this.setState({ [debouncedState]: currentState[inputState] });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.userInputValueTimeoutId);
    clearTimeout(this.ownerInputValueTimeoutId);
  }

  getFilteredUserOptions(debouncedValue) {
    if (!debouncedValue) {
      return this.state.userOptions.slice(0, 100);
    }
    return this.state.userOptions
      .filter(option =>
        option.label.toLowerCase().includes(debouncedValue.toLowerCase())
      )
      .slice(0, 500);
  }

  getAllUser = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showUserLoadSpinner: true, showUserOwnerLoadSpinner: true });
    UserProxy.GetAllGenericUserMini((response) =>
      this.setAllUserData(response)
    );
  };

  setAllUserData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      userOptions: optionsArray,
      newUser:
        this.state.newUser === "" && optionsArray.length > 0
          ? [optionsArray[0]]
          : this.state.newUser,
      showUserLoadSpinner: false,
      newVirtualTeamOwners:
        this.state.newVirtualTeamOwners === "" && optionsArray.length > 0
          ? [optionsArray[0]]
          : this.state.newVirtualTeamOwners,
      showUserOwnerLoadSpinner: false,
    });
  };

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newVirtualTeam,
      description: this.state.newdescription,
      virtualteamusers: fullOptionToUserValue(this.state.newUser),
      virtualteamowners: fullOptionToOwnerValue(
        this.state.newVirtualTeamOwners
      ),
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateVirtualTeamPresent = (virtualTeamEntered) => {
    if (!virtualTeamEntered || virtualTeamEntered.trim() === "") return;

    this.setState({
      validateVirtualTeamPresentSpinner: true,
    });

    VirtualTeamProxy.CheckVirtualTeamAvailable(
      virtualTeamEntered,
      (response) => {
        //if we got response that means virtualTeam is present at backend
        if (response) {
          //VirtualTeamName already present
          this.setState({
            validateVirtualTeamPresentSpinner: false,
            showValidationMessage: true,
            virtualTeamAvailable: false,
          });
        } else {
          //VirtualTeamName not available, so can be used
          this.setState({
            validateVirtualTeamPresentSpinner: false,
            showValidationMessage: true,
            virtualTeamAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      (this.state.newUser.length === 0 ||
        this.state.newVirtualTeam.length === 0 ||
        this.state.newVirtualTeamOwners.length === 0)
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.virtualTeamAvailable ||
        this.state.newUser.length === 0 ||
        this.state.newVirtualTeam.length === 0 ||
        this.state.newVirtualTeamOwners.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add virtualTeam validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        {this.state.showUserDetailModal && (
          <UserDetailModal
            show={true}
            handleClose={() => this.setState({ showUserDetailModal: false })}
            handleSelect={(selectedOption) => {
              const selectedData = this.state.userOptions.filter(opt => selectedOption.includes(opt.value));
              if (this.state.userDetailContext === "U") {
                this.setState({
                  userDetailContext: "",
                  showUserDetailModal: false,
                  newUser: selectedData,
                });
              } else if (this.state.userDetailContext === "O") {
                this.setState({
                  userDetailContext: "",
                  showUserDetailModal: false,
                  newVirtualTeamOwners: selectedData,
                });
              }
            }}
            userids={(this.state.userOptions.filter(opt => opt.value !== "*")).map(cust => cust.value)}
            selectedIds={
              this.state.userDetailContext === "U"
                ? this.state.newUser.length > 0 ? this.state.newUser.map(i => i.value) : []
                : this.state.newVirtualTeamOwners.length > 0 ? this.state.newVirtualTeamOwners.map(i => i.value) : []
            }
            usertype={"U"}
            loading={this.state.showUserDetailModal}
            isMulti={true}
          />
        )}

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} size="lg" enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit VirtualTeam"
                : "Add New VirtualTeam"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              sx={{
                width: "100%",
                "& .css-2vawn2-MuiTypography-root": {
                  alignSelf: "center",
                },
              }}
            >
              {this.props.editOperation ? (
                <Box sx={{ display: "flex", width: "100%", mb: 2 }}>
                  <Typography sx={{ width: "30%" }}>Id</Typography>
                  <Typography sx={{ fontWeight: "bold", width: "100%" }}>
                    {this.props.sourceData.id}
                  </Typography>
                </Box>
              ) : null}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "30%" }}>
                  Virtual Team <sup style={{ color: "red" }}>*</sup>
                </Typography>
                {this.props.editOperation ? (
                  <Typography sx={{ width: "100%" }}>
                    {this.state.newVirtualTeam}
                  </Typography>
                ) : (
                  <TextField
                    margin="normal"
                    sx={{ mb: 1 }}
                    fullWidth
                    size="small"
                    label="Virtual Team (required)"
                    placeholder="Enter Virtual Team"
                    value={this.state.newVirtualTeam}
                    autoFocus
                    onBlur={(e) =>
                      this.validateVirtualTeamPresent(this.state.newVirtualTeam)
                    }
                    onChange={(e) =>
                      this.setState({
                        newVirtualTeam: e.target.value,
                        showValidationMessage: false,
                        virtualTeamValidationError: Utility.CheckIsPresent(
                          e.target.value
                        )
                          ? ""
                          : "Virtual Team Cannot be Empty",
                      })
                    }
                    helperText={this.state.virtualTeamValidationError}
                    error={this.state.virtualTeamValidationError.length > 0}
                  />
                )}
              </Box>
              <Box display={"flex"} alignItems="center">
                <Box minWidth={"25%"}></Box>
                <Box>
                  {this.state.validateVirtualTeamPresentSpinner ? (
                    <CircularProgress size="1rem" />
                  ) : !this.state.showValidationMessage ? (
                    <Box>&nbsp;</Box>
                  ) : this.state.virtualTeamAvailable ? (
                    <font color="green">VirtualTeam available</font>
                  ) : (
                    <font color="red">VirtualTeam not available</font>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "30%" }}>Description</Typography>
                <TextField
                  sx={{ mt: 1 }}
                  margin="normal"
                  fullWidth
                  size="small"
                  label="Description"
                  placeholder="Description"
                  value={this.state.newdescription}
                  onChange={(e) =>
                    this.setState({
                      newdescription: e.target.value,
                    })
                  }
                />
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "25%", alignSelf: "center" }}>
                  Users
                </Typography>
                <Box sx={{ width: "80%", m: 0 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    value={this.state.newUser}
                    isSearchable={true}
                    isMulti
                    closeMenuOnSelect={false}
                    name="All Users"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.getFilteredUserOptions(this.state.debouncedUserInputValue)}
                    onChange={(e) => this.setState({ newUser: e })}
                    inputValue={this.state.userInputValue}
                    onInputChange={(inputValue) => this.setState({ userInputValue: inputValue })}
                  />
                </Box>
                <Tooltip title="View More Data">
                  <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                    <OpenInNewIcon
                      style={{ fontSize: "20px", marginTop: "9px" }}
                      onClick={() => {
                        this.setState({ showUserDetailModal: true, userDetailContext: "U" });
                      }}
                      color="action"
                    />
                  </span>
                </Tooltip>
                {this.state.showUserLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllUser(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "25%", alignSelf: "center" }}>
                  Owners
                </Typography>
                <Box sx={{ width: "80%", m: 0 }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    value={this.state.newVirtualTeamOwners}
                    isSearchable={true}
                    isMulti
                    closeMenuOnSelect={false}
                    name="All Users"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.getFilteredUserOptions(this.state.debouncedOwnerInputValue)}
                    onChange={(e) => this.setState({ newVirtualTeamOwners: e })}
                    inputValue={this.state.ownerInputValue}
                    onInputChange={(inputValue) => this.setState({ ownerInputValue: inputValue })}
                  />
                </Box>
                <Tooltip title="View More Data">
                  <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                    <OpenInNewIcon
                      style={{ fontSize: "20px", marginTop: "9px" }}
                      onClick={() => {
                        this.setState({ showUserDetailModal: true, userDetailContext: "O" });
                      }}
                      color="action"
                    />
                  </span>
                </Tooltip>
                {this.state.showUserOwnerLoadSpinner ? (
                  <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                ) : (
                  <Tooltip title="Reload">
                    <RefreshOutlinedIcon
                      color="primary"
                      fontSize="medium"
                      onClick={() => this.getAllUser(true)}
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
